import { render, staticRenderFns } from "./ffc_banner.vue?vue&type=template&id=df4b77e0"
import script from "./ffc_banner.vue?vue&type=script&lang=js"
export * from "./ffc_banner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports